import { styled } from '@mui/material'
import KeyboardReturnRounded from '@mui/icons-material/KeyboardReturnRounded'
import CheckRounded from '@mui/icons-material/CheckRounded'
import { intl } from '../../../../../../../../../i18n'
import { colorPalette } from '../../../../../../../../style/colorPalette'
import { EllipsisText } from '../../../../components/EllipsisText'

type PageTitleSuggestionButtonProps = {
  suggestedTitle: string | undefined
  isApplied: boolean
  onApply: () => void
}

export const PageTitleSuggestionButton = ({
  suggestedTitle,
  isApplied,
  onApply,
}: PageTitleSuggestionButtonProps) => {
  if (!suggestedTitle) {
    return (
      <SuggestionButton type="button" disabled={true}>
        {intl.formatMessage({
          id: 'versionReport.pageConfig.pageTitle.suggestion.empty',
        })}
      </SuggestionButton>
    )
  }
  if (isApplied) {
    return (
      <AppliedButton type="button" disabled={true}>
        <CheckRounded />
        {intl.formatMessage({
          id: 'versionReport.pageConfig.pageTitle.suggestion.applied',
        })}
      </AppliedButton>
    )
  }
  return (
    <SuggestionButton type="button" onClick={onApply}>
      <KeyboardReturnRounded />
      <SuggestedTitle>{suggestedTitle}</SuggestedTitle>
      <ApplyLabel>
        {intl.formatMessage({
          id: 'versionReport.pageConfig.pageTitle.suggestion.apply',
        })}
      </ApplyLabel>
    </SuggestionButton>
  )
}

const SuggestionButton = styled('button')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  minWidth: 0,
  height: '28px',
  marginTop: '8px',
  padding: '0 10px 0 8px',
  border: `1px dashed ${colorPalette.skyBlue[2]}`,
  borderRadius: '14px',
  background: colorPalette.monotone[0],
  color: colorPalette.skyBlue[8],
  fontFamily: 'inherit',
  fontSize: '12px',
  cursor: 'pointer',
  '& svg': {
    fontSize: '16px',
    flexShrink: 0,
  },
  '&:hover:not(:disabled)': {
    background: colorPalette.skyBlue[1],
    borderStyle: 'solid',
  },
  '&:disabled': {
    borderColor: colorPalette.monotone[2],
    color: colorPalette.monotone[3],
    cursor: 'default',
  },
})

const AppliedButton = styled(SuggestionButton)({
  '&:disabled': {
    border: '1px solid transparent',
    background: 'transparent',
    color: colorPalette.monotone[4],
  },
})

const SuggestedTitle = styled(EllipsisText)({
  minWidth: 0,
})

const ApplyLabel = styled('span')({
  flexShrink: 0,
  fontWeight: 700,
})
